module.exports = "/_next/static/images/main-visual-menu@2x-2f5ad33fda59fe1d14e24cf29d16a4dc.jpg";